module.exports = function(a, b){
  if (a.substr(-1) == '/') a = a.substr(0, a.length - 1);
  if (b[0] == '/') b = b.slice(1);
  return a + '/' + b;
}
